import React from 'react';
import { Icon } from './Icon.js';
export const IconCircleMinusFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM3.75 5.25C3.33579 5.25 3 5.58579 3 6C3 6.41421 3.33579 6.75 3.75 6.75H8.25C8.66421 6.75 9 6.41421 9 6C9 5.58579 8.66421 5.25 8.25 5.25H3.75Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconCircleMinusFill12.js.map